import { element } from "prop-types";
import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class SelectionMenu extends AbstractProvidedClass {
    initialized = false;
    menu = null;
    items = [];

    constructor(provider, mode) {
        super(provider);
        this.mode = mode;
    }

    refresh(hovered, arg) {
        this.remove();
        this._onPick = typeof arg === 'function' ? arg : null;
        this.species = typeof arg === 'function' ? null : arg;
        this.initialize(hovered);
        this.initialized = true;
    }

    initialize(hovered) {
        this.menu = this.p.createDiv()
            .position(this.p.mouseX, this.p.mouseY)
            .style('border', '2px solid black')
            .attribute('oncontextmenu', 'return false');
        this.items = hovered.map((element) => {
            let label = element.labels.hasLabels() ? `${element.name} (${element.title})` : element.title;
            let el = this.p.createDiv(label).parent(this.menu)
                .style('width', 'auto')
                .style('height', 'auto')
                .style('padding', '3px 5px')
                .style('background', element.selected ? '#ffaa66' : '#ffffff');
            el.mouseOver(() => {
                el.style('background', '#ffee66');
                this.hoverSet.add(element);
            });
            el.mouseOut(() => {
                el.style('background', element.selected ? '#ffaa66' : '#ffffff');
                this.hoverSet.remove(element);
            });
            el.mouseClicked(() => {
                this.hoverSet.reset();
                this.mode == 'edit'
                    ? this.editClick(element)
                    : this.viewClick(element);
            });
            return {
                'element': element,
                'div': el,
            };
        });
    }

    editClick(element) {
        if (this._onPick) {
            this._onPick(element);
            return;
        }
        if (this.tools.currentTool == this.getTool('select')) {
            this.selection.click(element);
            this.setItemColors();
        } else {
            element.speciesIds.push(this.species.id);
            this.speciesCollection.addObject(this.species.id, element);
            element.flash();
        }
    }

    viewClick(element) {
        if (element.selected) {
            this.selection.remove(element);
        } else {
            this.selection.select(element);
            this.sideBar.setTab('info');
            this.remove();
        }
        this.setItemColors();
    }

    setItemColors() {
        this.items.map((item) => {
            let color = item.element.isHovered
                ? '#ffee66'
                : (item.element.selected ? '#ffaa66' : '#ffffff');
            item.div.style('background', color);
        });
    }

    remove() {
        this.menu ? this.menu.remove() : null;
        this.items = [];
        this.initialized = false;
    }
}
